
import { RevenueOrg } from '../RevenueOrg';

export class RevenueOrgFa extends RevenueOrg {

  constructor(props) {
    super(props, {pageForOrgType: 'FA'})
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/fas/RevenueOrgFa.js